export default "__VITE_ASSET__0c394c84__"